import ModalContent from '@/components/modal/ModalContent.tsx';
import { TextInput } from '@/components/form/TextInput.tsx';
import CheckboxInput from '@/components/form/CheckboxInput.tsx';
import TwoInputsRow from '@/components/form/ui/TwoInputsRow.tsx';
import { ValueInput } from '@/components/form/ValueInput.tsx';
import { useFormContext } from 'react-hook-form';
import React from 'react';
import InputLabel from '@/components/form/base/InputLabel.tsx';
import PrimitiveInput from '@/components/form/_primitives/PrimitiveInput.tsx';
import InputHint from '@/components/form/base/InputHint.tsx';
import { TextCustomFieldInputData } from '@/features/dashboard/tourCustomFields/schemas/textCustomFieldSchema.ts';

const TextCustomFieldForm = () => {
  const {
    register,
    formState: { errors },
    watch,
    setValue,
  } = useFormContext<TextCustomFieldInputData>();

  const isCharacterLimitEnabled = watch('isCharacterLimitEnabled');

  const onCharLimitEnabledChange = (enabled: boolean) => {
    if (!enabled) {
      setValue('minChars', undefined);
      setValue('maxChars', undefined);
    }
  };

  return (
    <>
      <ModalContent>
        <div className="text-sm text-neutral-600">
          Skonfiguruj jak powinno wyświetlać się to pole w formularzu.
        </div>

        <TextInput
          label="Nazwa pola"
          register={register('fieldName')}
          placeholder="Wpisz nazwę pola..."
          required={true}
          error={errors.fieldName?.message}
          hint="Tak będzie oznaczone to pole na formularzu "
        />

        <CheckboxInput
          label="Pole wymagane"
          register={register('isFieldMandatory')}
          error={errors.isFieldMandatory?.message}
        />

        <TwoInputsRow ratio="1/2" className="items-center">
          <CheckboxInput
            label="Ustaw limit znaków"
            register={register('isCharacterLimitEnabled')}
            error={errors.isCharacterLimitEnabled?.message}
            onChange={(e) => onCharLimitEnabledChange(e.target.checked)}
          />
          {isCharacterLimitEnabled && (
            <TwoInputsRow>
              <ValueInput
                label="Min. liczba znaków"
                type="number"
                register={register('minChars', { valueAsNumber: true })}
                placeholder="0"
                error={errors.minChars?.message}
                required
              />
              <ValueInput
                label="Max. liczba znaków"
                type="number"
                register={register('maxChars', { valueAsNumber: true })}
                placeholder="0"
                error={errors.maxChars?.message}
                required
              />
            </TwoInputsRow>
          )}
        </TwoInputsRow>

        <TextInput
          label="Sugerowana treść"
          register={register('placeholder')}
          placeholder="Wpisz sugerowaną treść..."
          error={errors.placeholder?.message}
          hint="Pojawi się w polu przed rozpoczęciem wypełniania pola"
        />

        <TextInput
          label="Tekst pomocniczy"
          register={register('hint')}
          placeholder="Wpisz tekst pomocniczy..."
          error={errors.hint?.message}
          hint="Pojawi się poniżej pola, może wyjaśnić uczestnikowi jak powinien wypełnić pole"
        />
      </ModalContent>
      <ModalContent>
        <h3 className="text-xl font-semibold leading-[120%]">Podgląd</h3>
      </ModalContent>
      <ModalContent className="bg-neutral-100">
        <CustomFieldTextPrimitiveInputPreview />
      </ModalContent>
    </>
  );
};

const CustomFieldTextPrimitiveInputPreview = () => {
  const { watch } = useFormContext<TextCustomFieldInputData>();

  const fieldName = watch('fieldName');

  let title = 'Wpisz nazwe pola';
  if (fieldName && fieldName.length > 0) {
    title = fieldName;
  }

  return (
    <div className="flex w-full flex-col items-start gap-1.5">
      <InputLabel label={title} required={watch('isFieldMandatory')} />
      <PrimitiveInput placeholder={watch('placeholder')} />
      <InputHint hint={watch('hint')} />
    </div>
  );
};

export default TextCustomFieldForm;
